import { clientesApi } from "page/OrderResumePag/_services/api";
import api from "../../../_services/api";
import {
  isMainAddress,
  normalizeAddressFromApi,
} from "../addressUtils";

function extractAddressList(responseData) {
  const payload = responseData?.data ?? responseData;

  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.addresses)) return payload.addresses;
  if (Array.isArray(payload?.items)) return payload.items;

  return [];
}

export async function getAddress(customerUuid, addressUuid) {
  const response = await api.get(
    `/api/list-address?addressUuid=${addressUuid}&customerUuid=${customerUuid}`,
  );
  return response.data;
}

export async function addAddress(address) {
  const payload = mapAddressPayload(address);

  const response = await clientesApi.post(`/customer/address`, payload);
  return response;
}

export async function deleteAddress(addressUuid) {
  const response = await clientesApi.delete(
    `/customer/address/${addressUuid}`,
  );
  return response.data;
}

export async function getAddresses() {
  const response = await clientesApi.get(`/customer/address`);
  const list = extractAddressList(response.data);

  return list.map(normalizeAddressFromApi);
}

export async function editAddresses(address) {
  const addressCopy = { ...address };
  addressCopy.addressUuid = addressCopy.uuid;
  delete addressCopy.uuid;

  const pld = mapAddressPayload(addressCopy);
  const response = await clientesApi.put(
    `/customer/address/${addressCopy.addressUuid}`,
    pld,
  );
  return response;
}

function mapAddressPayload(address) {
  return {
    label: address.label,
    streetName: address.streetName,
    neighborhood: address.neighborhood,
    complement: address.complement,
    number: address.number,
    zipCode: address.cep || address.zipCode,
    city: address.city,
    state: address.state,
    main: isMainAddress(address),
    recipient: address.recipient,
    reference: address.reference,
  };
}
